import { BaseFormProps } from "./types";

export function BaseForm({ onSubmit, children }: BaseFormProps) {
  return (
    <form onSubmit={onSubmit} style={{ width: "100%" }}>
      {children}
    </form>
  );
}
